import React, { useState } from 'react';
import { calculatorAPI } from '../services/api';

const TreasuryBillCalculator = () => {
  const [faceValue, setFaceValue] = useState('');
  const [yieldRate, setYieldRate] = useState('');
  const [tenor, setTenor] = useState('91');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCalculate = async (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    if (!faceValue || parseFloat(faceValue) <= 0 || !yieldRate || parseFloat(yieldRate) <= 0) {
      setError('Please enter valid face value and yield rate.');
      return;
    }

    setLoading(true);
    try {
      const data = await calculatorAPI.calculateTBill(
        parseFloat(faceValue),
        parseFloat(yieldRate),
        tenor
      );
      setResult(data);
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-KE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  return (
    <div>
      <h3>Treasury Bill Calculator</h3>
      <form onSubmit={handleCalculate}>
        <input
          type="number"
          id="faceValue"
          placeholder="Face Value (KES)"
          value={faceValue}
          onChange={(e) => setFaceValue(e.target.value)}
          step="0.01"
          min="0"
        />
        <input
          type="number"
          id="yieldRate"
          placeholder="Annual Yield (%)"
          value={yieldRate}
          onChange={(e) => setYieldRate(e.target.value)}
          step="0.01"
          min="0"
          max="100"
        />
        <select
          id="tenor"
          value={tenor}
          onChange={(e) => setTenor(e.target.value)}
        >
          <option value="91">91 Days</option>
          <option value="182">182 Days</option>
          <option value="364">364 Days</option>
        </select>
        <button type="submit" disabled={loading}>
          {loading ? 'Calculating...' : 'Calculate Return'}
        </button>
      </form>

      {error && (
        <div className="error" role="alert">
          <span className="error-icon">⚠️</span>
          {error}
        </div>
      )}
      
      {loading && (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p className="loading-text">Calculating your returns...</p>
        </div>
      )}

      {result && result.success && (
        <div className="results">
          <div className="results-header">
            <span className="results-icon">📊</span>
            <span className="results-title">Investment Analysis</span>
          </div>
          <div className="results-content">
            <div className="result-item highlight">
              <span className="result-label">Net Profit</span>
              <span className="result-value">KES {formatCurrency(result.netProfit)}</span>
            </div>
            <div className="result-item">
              <span className="result-label">Investment Cost</span>
              <span className="result-value">KES {formatCurrency(result.investmentCost)}</span>
            </div>
            <div className="result-item">
              <span className="result-label">Gross Interest</span>
              <span className="result-value">KES {formatCurrency(result.grossInterest)}</span>
            </div>
            <div className="result-item">
              <span className="result-label">Withholding Tax (15%)</span>
              <span className="result-value">KES {formatCurrency(result.tax)}</span>
            </div>
            <div className="result-item info">
              <span className="result-label">Tenor</span>
              <span className="result-value">{result.days} Days</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TreasuryBillCalculator;
